import { useContext } from 'react';
//import FirebaseContext from '../contexts/FirebaseContext';
import LoginContext from '../contexts/loginContext';
//import Auth0Context from '../contexts/Auth0Context';

const useAuth = () => useContext(LoginContext);


export default useAuth;
